import { UsersFilterTypes } from '../constants';
import { UsersPageParams } from '../state/users.model';

export interface UsersActionsBarFilter {
    type: UsersFilterTypes;
    value: string;
}

export type UserActionsBarFilterParams = UsersPageParams;
